import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loanDrilldownClear,
  loanDrilldownSet,
} from "../redux/actions/loanDrilldownActions";
import { sidebarReset } from "../redux/actions/sidebarActions";
import { loanFetchedDataClearAll } from "../redux/reducers/loanFetchedDataReducer";
import { useUnderwritingHook } from "./useUnderwritingHook";

export const useReduxLoanDrilldownHook = () => {
  const dispatch = useDispatch();
  const { getLoanById } = useUnderwritingHook();
  const clearLoanDrilldownData = useCallback(() => {
    dispatch(loanFetchedDataClearAll());
    dispatch(sidebarReset());
    dispatch(loanDrilldownClear());
  }, []);

  const clearLoanDrilldownSidebarData = useCallback(() => {
    dispatch(sidebarReset());
  }, []);

  const clearLoanDrilldownFetchedData = useCallback(() => {
    dispatch(loanFetchedDataClearAll());
  }, []);

  const clearLoanDrilldownMeta = useCallback(() => {
    dispatch(loanFetchedDataClearAll());
    dispatch(sidebarReset());
  }, []);

  const clearFetchSetLoanDrilldown = useCallback(({ loanId }) => {
    clearLoanDrilldownData();
    getLoanById({
      loanId,
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
      },
      onFailFn: () => dispatch(loanDrilldownSet({})),
    });
  }, []);

  return {
    clearLoanDrilldownData,
    clearLoanDrilldownSidebarData,
    clearLoanDrilldownFetchedData,
    clearLoanDrilldownMeta,
    clearFetchSetLoanDrilldown,
  };
};
